import { defineStore } from 'pinia'
import { usePermissionAccessStore } from '@/stores/common/permissionAccess'

export const usePermission = defineStore('permission', {
  state: () => ({
    permissions: [],
    permissionMap: new Map()
  }),

  actions: {
    async loadPermissions(userId) {
      const permissionAccessStore = usePermissionAccessStore()

      const data = await permissionAccessStore.fetchUserPermissionAsync(userId)

      this.permissions = data || []

      const map = new Map()
      this.permissions.forEach(p => {
        if (p.actionName) {
          map.set(p.actionName, p.hasAccess === true)
        }
      })

      this.permissionMap = map
    },

    hasAccess(actionName) {
      if (!actionName) return true
      return this.permissionMap.get(actionName) === true
    }
  }
})